import { axiosApiInstance } from "@/lib/axios";
import { API_PORTAL_URL } from "@/lib/config";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const getAllActiveTickets = createAsyncThunk(
  "Website/FindAllSAOUTicketList",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_PORTAL_URL}/Website/FindAllSAOUTicketList`,
      );
      return response.data?.Data;
    } catch (error: any) {
      const err = error as { response?: { data?: { Details?: string } } };
      console.error("Error Fetching tickets:", error);
      return Promise.reject({
        message: err?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);
export const getAllActiveSOUPackages = createAsyncThunk(
  "SOUPackage/FindAllActiveSOUPackage",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_PORTAL_URL}/SOUPackage/FindAllActiveSOUPackage`,
      );
      return response.data?.Data;
    } catch (error: any) {
      const err = error as { response?: { data?: { Details?: string } } };
      console.error("Error Fetching tickets:", error);
      return Promise.reject({
        message: err?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export async function fetchAllActiveTickets() {
  try {
    const response = await fetch(
      `${API_PORTAL_URL}/Website/FindAllSAOUTicketList`,
      {
        method: "GET",
        cache: "no-store",
      },
    );
    const data = await response.json();
    return data?.Data || [];
  } catch (error) {
    console.error("Error fetching all active tickets:", error);
    return [];
  }
}

export async function fetchTicketByURL(TicketURL: string) {
  try {
    const response = await fetch(
      `${API_PORTAL_URL}/SOUTicket/FindByURLSOUTicket`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ TicketURL }),
        cache: "no-store",
      },
    );
    const data = await response.json();
    return data?.Data || null;
  } catch (error) {
    console.error("Error fetching ticket by URL:", error);
    return null;
  }
}

export const fetchTicketByURLAPI = createAsyncThunk(
  "SOUTicket/FindByURLSOUTicket",
  async (TicketURL: string) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_PORTAL_URL}/SOUTicket/FindByURLSOUTicket`,
        {
          TicketURL: TicketURL,
        },
      );
      const data = response.data;
      return data?.Data || null;
    } catch (error) {
      console.error("Error fetching ticket by URL:", error);
      return null;
    }
  },
);
